var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('menu-modifications',{on:{"seleccion":_vm.seleccion}}),(_vm.elegido == 0)?_c('ensayos'):_c('h-m-i')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }